import type { FilterableField } from 'components/organisms/tasks/fields';
import { GroupSeparator } from 'components/organisms/tasks/filters/separators';

export const getFieldString = (field: FilterableField) => {
  if (field?.customField && field.userCreated) {
    return `${field?.sourceType}${GroupSeparator}field.${field.fieldId}`;
  }

  return `${field.sourceType}${GroupSeparator}${field.fieldName}`;
};
